/**
 * @file ProjectSourceFirebase.tsx
 * @description Migration placeholder for Firebase project source.
 * Original implementation moved to _archive/firebase.
 * This stub prevents import errors during Supabase migration.
 */

import { ReactNode } from 'react';
import { atom } from 'jotai';

/**
 * Placeholder Firebase config
 * @deprecated Use Supabase config instead
 */
export const envConfig = {};

/**
 * Placeholder Firebase config atom
 * @deprecated Use Supabase config instead
 */
export const firebaseConfigAtom = atom({});

/**
 * Placeholder Firebase app atom
 * @deprecated Use Supabase instead
 */
export const firebaseAppAtom = atom({});

/**
 * Placeholder Firebase auth atom
 * @deprecated Use Supabase auth instead
 */
export const firebaseAuthAtom = atom({});

/**
 * Placeholder Firebase database atom
 * @deprecated Use Supabase database instead
 */
export const firebaseDbAtom = atom({});

/**
 * Placeholder Firebase functions atom
 * @deprecated Use Supabase Edge Functions instead
 */
export const firebaseFunctionsAtom = atom({});

/**
 * Placeholder Firebase storage atom
 * @deprecated Use Supabase storage instead
 */
export const firebaseStorageAtom = atom({});

/**
 * Placeholder Firebase auth object
 * @deprecated Use Supabase auth instead
 */
export const firebaseAuth = {
  currentUser: null,
  signOut: async () => {
    console.warn('firebaseAuth.signOut() is deprecated. Use Supabase auth.');
  },
  onAuthStateChanged: () => () => {},
};

/**
 * Placeholder Firestore object
 * @deprecated Use Supabase database instead
 */
export const firestore = {
  collection: () => ({
    doc: () => ({
      get: async () => ({ exists: false, data: () => ({}) }),
      set: async () => {},
      update: async () => {},
      delete: async () => {},
    }),
  }),
};

/**
 * Placeholder Firebase functions object
 * @deprecated Use Supabase Edge Functions instead
 */
export const functions = {
  httpsCallable: () => async () => ({ data: null }),
};

export interface ProjectSourceFirebaseProps {
  children: ReactNode;
}

export interface MembersSourceFirebaseProps {
  children: ReactNode;
}

/**
 * Empty ProjectSourceFirebase component
 * @deprecated This component is being replaced by ProjectSourceSupabase
 */
export const ProjectSourceFirebase: React.FC<ProjectSourceFirebaseProps> = ({
  children,
}) => {
  console.warn(
    'ProjectSourceFirebase is deprecated. Use ProjectSourceSupabase instead.'
  );
  return <>{children}</>;
};

export default ProjectSourceFirebase;
